import { cn } from "@/lib/utils";

interface CardRowProps {
  children: React.ReactNode;
  active?: boolean;
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void;
}

const CardRow = ({ children, active, onClick }: CardRowProps) => (
  <article
    className={cn(
      "flex flex-row w-full h-24 touch-device:rounded-lg bg-panel-background touch-device:h-28 group",
      active && "bg-panel-foreground",
      !active && onClick && "desktop:hover:bg-panel-middleground",
      onClick ? "cursor-pointer" : "cursor-default",
    )}
    onClick={onClick}
  >
    {children}
  </article>
);

export default CardRow;
